
/* injects from baggage-loader */

'use strict';

export default class CookiePolicyController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
